import { useMatch } from 'react-router-dom';

export function useIsInsidePath(path: string): boolean {
  return useMatch({ path, end: false }) !== null;
}
